import { render, staticRenderFns } from "./ModalCommision.vue?vue&type=template&id=61fbec1d"
import script from "./ModalCommision.vue?vue&type=script&lang=js"
export * from "./ModalCommision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports